import DimensionResolver from '@/composables/charts/influx-charts/dimension-resolvers/DimensionResolver.js'

/**
 * Catch-All Fallback resolver. Matches Everything, and just returns the provided Tag-Value.
 */
class FallbackDimensionResolver extends DimensionResolver {
  async doesTagKeyMatch() {
    return true
  }

  async humanizeTagValue(tagValue) {
    return tagValue
  }
  static isRelevantForCurrentInstance() {
    return true
  }
}

export default FallbackDimensionResolver
